import { Component, inject } from '@angular/core';
import { CustomBreadcrumbState } from '@services/state/custom-breadcrum.state';
import { BreadcrumbModule } from 'primeng/breadcrumb';

@Component({
  selector: 'app-custom-breadcrumbs',
  standalone: true,
  imports:[BreadcrumbModule],
  template: `
    @if (customBreadcrumbState.customItems()) {
      <p-breadcrumb
        [model]="customBreadcrumbState.customItems()!"
        styleClass="!pb-0 !pl-4 !pt-0 !bg-surface-50 mb-4 cursor-pointer" />
    }
  `,
})
export class CustomBreadcrumbsComponent {
  customBreadcrumbState = inject(CustomBreadcrumbState);
}
